<!-- Main section - right -->
<div class="d-flex flex-column h-100" id="deviceBannerCarousel">
  <div class="right_section_header" id="rightSectionHeader">
    <span class="banner-carousel_icons"></span>
    <span i18n="@@device.banner-carousel-section.heading">BANNER CAROUSEL</span>
  </div>
  <div class="mt-3" [ngClass]="(isBannerEmpty || isBannerEmpty === undefined) ? 'existing_text_show': 'existing_text_hide'" id="noBannerDiv">
    <span i18n="@@devices.side-menu.no-banner-carousel-msg">There are no
      banner carousels in the Asset Library</span>
  </div>
  
  <div class="right_section_body" *ngIf="bannerLength" id="rightSectionBody">
    <strong>{{bannerLength}}
      <span i18n="@@device.banner-carousel-grp-section.heading">Banner Carousel Groups</span>
    </strong>
    <div class="mt-4" id="select3banner">
      <span i18n="@@device.banner-carousel-sub.heading">You can only select 3 Banner Carousel content groups of up to 3
        pages on the home page of IPOS.</span>
    </div>
    <div class="mt-2" id="noteDiv" *ngIf='!isNonConnectedUser && !selectLength'>
      <span i18n="@@device.banner-carousel-sub.heading-note"><strong>Note:</strong> Banner Carousel can be updated only in Windows*, Windows* 10 and Linux* IPOS.</span>
    </div>
  </div>
  <div class="accordion" id="devicesBannerConAcc">
  <div class="card d-flex flex-row" id="devicesBannerConAccFlex">
    <div class="acc_check" id="devicesBannerConAccCheck">
        <div id="deviceBannerNone">
            <input type="radio" name="cpLCGSelect" [value]="isDeviceBannerNone" [checked]="isDeviceBannerNone"
                (change)="removeBannerShowonDevice()" />
        </div>
    </div>
    <div class="card-header-content" id="cardHeader">
        <div class="title_left none_title_left" id="titleLeft">
            <div class="d-flex" id="cardFlex">
                <div class="title none_title" id="cardTitle">
                    <span i18n="@@device-price-content.title.none-label">None</span>
                </div>
            </div>

        </div>
    </div>
</div>
</div>
  <iposcen-banner-carousel style='padding-bottom: 0 !important;' (sendBannerLength)="getBannerLength($event)" [checkedId]='checkIfEnabeled'
    [isDeviceBanner]='bannerActive' (bannerDataForDevice)="getDataChecked($event)">
  </iposcen-banner-carousel>
  <iposcen-spinner-overlay></iposcen-spinner-overlay>
  <div *ngIf="bannerLength" class="mt-1 text-center" id="bannerDataSize">
    {{bannerData.size}} 
    <span i18n="@@device-popup-banner-carousel.selected-banner-carousel-number-text">Selected</span>
  </div>
  <!-- CTA Buttons -->
  <div class="button_wrapper justify-content-end" *ngIf="bannerLength >= 0" id="deviceBannerCarousel">
    <button [disabled]='!isDeviceBannerNone && bannerData?.size === 0' type="button" class="btn btn-outline-primary btn-lg" data-dismiss="modal" (click)='cancel()'>
      {{cancelBtn}}
    </button>
    <button [disabled]='!isDeviceBannerNone && bannerData?.size === 0' type="button"
      class="btn btn-primary btn-lg gtmEditDeviceSavePromoContent" (click)="sendDataToStore()">
      <span i18n="@@device-banner-carousel.button.save-changes">Save Changes</span>
    </button>
  </div>
</div>

<!-- remove-popup-message -->
<div class="container" id="removePopupMessage">
  <div class="modal-dialog-centered" *ngIf="openModalPopup" id="modalDialog">
    <div class="modal-backdrop show" id="modalBackdropShow"></div>
    <div class="modal" id="myModal">
      <div class="modal-dialog" id="myModalDialog">
        <div class="modal-content" id="modalContent">
          <div class="close" (click)="closeModal()" id="modalClose">
            <img alt="close" class="modal-close-icon">
          </div>
          <div class="modal-body" [ngClass]="{'modal-body-cancel': isCancel}" id="modalBody">
            <div *ngIf='!isCancel' class="action_on_pending_user" id="actionOnPendingUser">
              <span class="success_img"></span>
            </div>
            <div class="action-success-msg" id="actionSuccessMsg">
              <span>{{successMessage}}</span>
            </div>
            <div class="card_desc" id="cardDesc">
              <span>{{description}}</span>
            </div>
          </div>
          <div *ngIf='isCancel' class='modal-footer' id="modalFooter">
            <button class='btn btn-outline-primary btn-lg' (click)="closeModal()">{{buttonLabelNo}}</button>
            <button class='btn btn-primary btn-lg' (click)='dismiss()'>{{buttonLabelCancel}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>